import { PostHogProvider } from "posthog-js/react";
import posthogJS, { PostHog } from "posthog-js";
import FeatureFlagsListener from "./feature-flags-listener";

declare global {
  interface Window {
    posthog?: PostHog;
  }
}

const POSTHOG_API_KEY = "phc_7H06ROj6qJO4V14Hfs6xKkLUxofriHj8sovBV2IZ6ae";

export function initFeatureFlagsService() {
  posthogJS.init(POSTHOG_API_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "https://eu.i.posthog.com",
  });
  window.posthog = posthogJS;
}

export function FeatureFlagsProvider({ children }: { children: React.ReactNode }) {
  return (
    <PostHogProvider client={posthogJS}>
      <FeatureFlagsListener />
      {children}
    </PostHogProvider>
  );
}
